"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiButtonBase = void 0;
exports.MuiButtonBase = {
    defaultProps: {
        disableRipple: true,
    },
};
//# sourceMappingURL=button-base.js.map